import {
    ListItemText as UiListItemText,
    L2RCheckbox,
    MenuItem,
    Skeleton as UiSkeleton,
    BottomSheet as L2RBottomSheet,
    Typography as UiTypography,
    styled,
    styledForMobile,
    L2RButton,
} from "@l2r-front/l2r-ui"

export const Checkbox = styledForMobile(L2RCheckbox)(({ isMobile, theme }) => ({
    flexDirection: isMobile ? "row-reverse" : "row",
    paddingLeft: isMobile && theme.spacing(3),
    justifyContent: isMobile && "space-between",
    width: isMobile && "100%",
    minWidth: 0,

    "& .MuiFormControlLabel-label": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        minWidth: 0,
    },
}))

export const CheckboxContainer = styled("div")(() => ({
    direction: "ltr",
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
}))

export const Button = styledForMobile(MenuItem)(({ isMobile, theme }) => ({
    display: "flex",
    flexDirection: isMobile ? "row-reverse" : "row",
    padding: isMobile ? theme.spacing(2, 4, 2, 2) : theme.spacing(1, 1, 1, 0),
    marginRight: isMobile && theme.spacing(3),
}))

export const AddCampaignButton = styledForMobile(Button)(({ isMobile, theme }) => ({
    height: !isMobile && 54,
    marginRight: isMobile ? theme.spacing(6) : `-${theme.spacing(1)}`,
    padding: isMobile ? theme.spacing(0, 0, 0, 2) : theme.spacing(2, 4, 2, 4)
}))

export const ListItemText = styled(UiListItemText)(({ theme }) => ({
    paddingLeft: theme.spacing(2),
}))

export const CampaignSelectorContainer = styledForMobile("div")(({ isMobile }) => ({
    height: "100%",
    width: isMobile ? "100%" : 310,
}))

export const Skeleton = styledForMobile(UiSkeleton)(({ isMobile, theme }) => ({
    height: 100,
    width: isMobile ? "100%" : 310,
    margin: theme.spacing(1, 1, 1, 0),
    transform: "scale(1)",
}))

export const Typography = styled(UiTypography)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
}))

export const Color = styledForMobile("div")(({ color, isMobile }) => ({
    borderRadius: 4,
    backgroundColor: color,
    height: 24,
    marginLeft: !isMobile ? "auto" : 0,
    width: 24,
    minWidth: 24,
}))

export const CheckboxWrapper = styledForMobile(MenuItem)(({ isMobile, theme }) => ({
    alignItems: "center",
    display: "flex",
    flexDirection: isMobile ? "row-reverse" : "row",
    gap: theme.spacing(2),
    padding: theme.spacing(2, isMobile ? 0 : 4, 2, 4),
}))


export const BottomSheet = styled(L2RBottomSheet)(({ theme }) => ({
    zIndex: theme.zIndex["modal"] + 1,
}))

export const Title = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(4),
}))

export const BottomSheetContent = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 4, 5, 4),
}))

export const ButtonsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    gap: theme.spacing(3),
    padding: theme.spacing(4, 4, 0, 4),
}))

export const BottomSheetButton = styled(L2RButton)(() => ({
    flex: 1,
}))